// extracted by mini-css-extract-plugin
export default {"inner":"About_inner__+-ZuZ","label":"About_label__SyKtG","value":"About_value__BlKqi","pillRow":"About_pillRow__iLRk5"};